import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose, setDisplayName } from 'recompose';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { injectIntl } from 'components';

const FOOTER_GROUPS = [
  {
    title: 'Company',
    items: [
      { label: 'About', link: '/about' },
      { label: 'FAQ', link: '/faq' },
      { label: 'Team', link: '/team' },
      { label: 'Contact us',link: '/contact'},
      { label: 'Jobs' },
    ],
  },
  /* {
    title: 'Features',
    items: [
      { label: 'Cool features', link: '/features' },
      // { label: 'Random feature' },
      // { label: 'Team feature' },
      // { label: 'Developer stuff' },
      // { label: 'Suggestions' },
    ],
  }, */
  {
    title: 'Resources',
    items: [
      { label: 'Request a Demo', url: 'https://calendly.com/freshr/30min?month=2020-03' },
      { label: 'Press' },
      { label: 'Twitter', url:'https://twitter.com/freshrfood' },
      { label: 'Facebook', url:'https://www.facebook.com/freshr.farmshop' },
      { label: 'Instagram', url: 'https://www.instagram.com/freshr_farmshop/' },
    ],
  },
  {
    title: 'Legal',
    items: [
      { label: 'Privacy policy', link: '/privacy' },
      { label: 'Terms of use', link: '/terms' },
    ],
  },
];

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1200 + (theme.spacing.unit * 3 * 2))]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  footer: {
    marginTop: theme.spacing.unit * 8,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit * 6}px 0`,
  },
  copyright: { marginTop: theme.spacing.unit * 8 },
});

const BasicFooter = ({ classes, formatMessage }) => (
  <footer className={classNames(classes.footer, classes.layout)}>
    <Grid container spacing={32} justify="space-evenly">
      {FOOTER_GROUPS.map(footerGroup => (
        <Grid item key={footerGroup.title}>
          <Typography variant="h6" color="textPrimary" gutterBottom>
            {formatMessage(footerGroup.title)}
          </Typography>

          {
            footerGroup.title.toLowerCase() === 'resources' ? (
              footerGroup.items.map(item => (
                <Typography     
                  title={item.title || item.label}          
                  key={item.label}
                  variant="subtitle1"
                  color="textSecondary"
                >
                 <a href={item.url} target="_blank" className="social-link">  {item.label}</a>

                </Typography>
              ))
            ) : (
              footerGroup.items.map(item => (
                item.mailto?
                <a className="jss496 jss514 jss529" title={item.title || item.label} href={`mailto:${item.mailto}`} key={item.label}>{item.label}</a>
                :            
                <Typography     
                  title={item.title || item.label}          
                  key={item.label}
                  variant="subtitle1"
                  color="textSecondary"
                  {...(item.link ? { component: Link, to: item.link } :{})}
                >
                  {item.label}
                </Typography>
              ))
            )
          }
    
        </Grid>
      ))}
    </Grid>
    <Typography className={classes.copyright} align="center" variant="caption" color="textSecondary">
      {formatMessage('Built with ❤️ by the FRESHr team')}
    </Typography>
  </footer>
);

BasicFooter.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default compose(
  setDisplayName('BasicFooter'),
  injectIntl,
  withStyles(styles),
)(BasicFooter);
